import { useContext } from 'react';

import { SettingsContext } from './settings-provider';

// ----------------------------------------------------------------------

export function useSettingsContext() {
  const context: any = useContext(SettingsContext);
  const _context = { ...context, palette: { mode: context?.colorSchemes } };

  if (!_context) throw new Error('useSettings _context must be use inside SettingsProvider');

  return _context;
}
